import { Button } from "@/components/ui/button";
import { scrollToConfigure } from "@/lib/useScrollReveal";
import { ArrowRight } from "@phosphor-icons/react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta"
      className="py-14 sm:py-20 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-[32px] p-10 sm:p-16 lg:p-20 bg-hero-gradient border border-white/10 shadow-[0_50px_120px_-30px_rgba(2,47,107,0.55)]">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-teal-brand/25 blur-3xl" />
            <div className="absolute -bottom-24 -left-16 h-80 w-80 rounded-full bg-royal/40 blur-3xl" />
          </div>
          <div className="relative max-w-3xl">
            <div className="overline text-teal-brand">Ready when you are</div>
            <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-[64px] font-bold text-white tracking-tight leading-[1.02]">
              Protect what you put in.
            </h2>
            <p className="mt-6 text-white/75 text-[17px] max-w-xl leading-relaxed">
              Join 10,000+ customers protecting their medications with CryoVault.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Button
                data-testid="final-cta-button"
                onClick={scrollToConfigure}
                className="group relative overflow-hidden h-14 px-8 rounded-full bg-cta-gradient text-white text-[15px] font-semibold border border-white/30 backdrop-blur-xl shadow-[inset_0_1px_0_rgba(255,255,255,0.55),inset_0_-1px_0_rgba(2,47,107,0.35),0_20px_50px_-14px_rgba(2,167,196,0.55)] hover:brightness-110 hover:-translate-y-0.5 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.75),inset_0_-1px_0_rgba(2,47,107,0.35),0_18px_40px_-14px_rgba(2,167,196,0.7),0_0_30px_-6px_rgba(1,207,198,0.55)] transition-all duration-300"
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-x-3 top-0 h-1/2 rounded-full bg-gradient-to-b from-white/45 to-transparent opacity-90"
                />
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -inset-y-1 -left-1/3 w-1/3 rotate-12 bg-gradient-to-r from-transparent via-white/55 to-transparent opacity-0 group-hover:opacity-100 group-hover:left-[110%] transition-all duration-700 ease-out"
                />
                <span className="relative z-10 inline-flex items-center">
                  Protect Your Peptides{" "}
                  <ArrowRight size={16} weight="bold" className="ml-1 group-hover:translate-x-1 transition-transform" />
                </span>
              </Button>
              <div className="font-mono-data text-white/60 text-[11px] uppercase tracking-widest">
                World Wide Shipping · 1 Year Warranty · 14-day Returns
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
